module.exports = __webpack_public_path__ + "static/media/3.54572343.png";